import { Tooltip } from '@ipfabric/ui-components/Tooltip/Tooltip';
import type { GraphPath } from '@ipfabric/utils';
import classNames from 'classnames';
import { GraphLayoutIcon } from 'components/Graph/GraphLayout/icons/GraphLayoutIcon';
import type {
  DeviceGroupAttributePathLayouts,
  TopologyGraphMetadata,
} from 'components/Graph/GraphState';
import { isFallbackLayout } from 'components/Graph/helpers/isFallbackLayout';
import type { MouseEvent } from 'react';
import type { AppTranslations } from 'translations/translations';
import type { PathOptionType } from './GraphNetworkViewerDataInputForm';

export const addLayoutIconsToPathOptions = (
  paths: PathOptionType[],
  pathLayouts: DeviceGroupAttributePathLayouts,
  msg: AppTranslations,
  onLayoutEditClick: (path: GraphPath) => void,
  topologyMetadata: TopologyGraphMetadata | null,
): PathOptionType[] => {
  const handleLayoutIconClick = (value: GraphPath) => (e: MouseEvent) => {
    e.stopPropagation();
    onLayoutEditClick(value);
  };

  return paths.map((path) => {
    const layout = pathLayouts[path.value];
    if (layout !== undefined) {
      return {
        value: path.value,
        label: (
          <span className='flex'>
            <span className='flex-1'>{path.label}</span>
            <span className='mr-5'>
              <Tooltip
                content={
                  msg.canvasGraph.graphSidePanel.networkViewerDataInput
                    .layoutIconTooltip
                }
              >
                <span
                  className={classNames(
                    'network-viewer__change-layout-icon inline-block',
                    !topologyMetadata?.nodesRepositioned.has(path.value) &&
                      isFallbackLayout(topologyMetadata?.paths[path.value]) &&
                      'text-red',
                  )}
                  onClick={handleLayoutIconClick(path.value)}
                >
                  <GraphLayoutIcon
                    title='Change layout'
                    layout={layout}
                    width={16}
                    height={16}
                    className='inline'
                  />
                </span>
              </Tooltip>
            </span>
          </span>
        ),
      };
    }
    return path;
  });
};
